import {SupportPoint, SupportPointRestControllerApiFactory} from "arteco-api-client-ts";
import AppList, {AppListConfig} from "../../../../components/layout/list";
import {useApiManager} from "../../../../components/utils/api";
import {Grid, TableCell} from "@mui/material";

export const SupportPointListPage = () => {
    const apiManager = useApiManager();

    const listConfig: AppListConfig<SupportPoint> = {
        title: "Preguntas de valoración",
        onClick: "/app/admin/compliance/supportpoint",
        headers: [
            {title:"Nombre"},
            {title:"Posición", align: "right", width: 120},
        ],
        decorator: (bean: SupportPoint) => (
            <>
                <TableCell >
                    {bean.label}
                </TableCell>
                <TableCell align="right" sx={{fontVariantNumeric: "tabular-nums"}}>
                    {bean.position}
                </TableCell>
            </>
        ),
        supplier: async (currentPage, size, term, showDismissed) => {
            
            const ctrl = apiManager.factory(SupportPointRestControllerApiFactory);
            return ctrl.pageSupportPoint(currentPage, size, undefined, term, showDismissed);
        },
    };

    return (
        <>
            <AppList config={listConfig} />
        </>
    );
};